import React from 'react';

import { TUserTenantSpecificRolesSelectAllCheckbox } from '@project44/iam-team-ui-utils/src/domains/User/domain/interfaces';
import * as ManifestUI from '@project44/manifest-ds';

import { TFunctionComponent } from '../../../../../shared/core/infrastructrue/types';

export const UseTenantSpecificRolesSelectAllCheckbox: TFunctionComponent<TUserTenantSpecificRolesSelectAllCheckbox> =
  ({
    config,
    availableTenantSpecificRoles,
    assignedUserTenantSpecificRolesState,
  }) => {
    const [
      assignedUserTenantSpecificRoles,
      updateAssignedUserTenantSpecificRoles,
    ] = assignedUserTenantSpecificRolesState;

    return (
      <ManifestUI.Checkbox
        role={'checkbox'}
        aria-label={`Select all tenant specific roles`}
        onChange={(isSelected) => {
          updateAssignedUserTenantSpecificRoles(
            config.handleOnChange(isSelected, assignedUserTenantSpecificRoles),
          );
        }}
        isSelected={config.isAllSelected(
          assignedUserTenantSpecificRoles,
          availableTenantSpecificRoles,
        )}
        isIndeterminate={config.isIndeterminate(
          assignedUserTenantSpecificRoles,
          availableTenantSpecificRoles,
        )}
      >
        {' '}
        <ManifestUI.Typography variant={'subtextBold'}>
          Grant access
        </ManifestUI.Typography>
      </ManifestUI.Checkbox>
    );
  };
